import { debounce } from '@/functions/general.js';

export default {
  data() {
    return { debounce: {} };
  },
  methods: {
		debounceM(key, filterFunction,callb){
			if (! this.debounce[key]){
				this.debounce[key] = debounce(function(){ filterFunction() && (callb && callb())}, 1500);
			}
			this.debounce[key](1500);
		},
  }, // methods
};
